import Padding from './Padding'

export default Padding
